import React, {Component} from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import shallowCompare from 'react-addons-shallow-compare'
import './css/DashboardIdeaList.css'

class DashboardIdeaList extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState)
  }
  render() {
    const {
      list,
      listId,
      listStyle,
      connectDropTarget,
      isDragging,
      children,
    } = this.props

    let listContainerClass = classnames({
      'ListContainer': true,
      'ListPlaceholder': isDragging,
    })

    let recColor = ''

    switch (listId) {
      case 'unrated':
        recColor = '#adadad'
        break
      case 'avoid':
        recColor = '#ce2f1b'
        break
      case 'maybe':
        recColor = '#f7a704'
        break
      case 'project':
        recColor = '#2d8fb0'
        break
      case 'do':
        recColor = '#3a7622'
        break
      default: 
        recColor = ''
    }

    return (
      <div className='ListWrapper' style={listStyle}>
        <div style={{backgroundColor: '#efefef'}} className={listContainerClass}>
          <div style={{textAlign: 'center', padding: '8px 0px'}} className='ListHeader'>
            <strong className='dashListTitle'>{listId}</strong>
            <span className='dashListIdeas'>
              {list.rows.length > 0 ? (
                <span>{list.rows.length} idea</span> 
              ):(
                <span>No ideas</span>
              )}
              {list.rows.length > 1 &&
                <span>s</span>
              }
              </span>
              {recColor !== '' &&
                <div style={{marginTop: 5+'px', height: 7+'px', width: 100+'%', backgroundColor: recColor}}/>
              }
          </div>
          {connectDropTarget(
            <div className='ListContent'>
              {children}
            </div>,
          )}
          {/* <div className='ListFooter'>
            <div className='ListActions'>
              <button className='ListActionItem'>Add a task...</button>
            </div>
          </div> */}
        </div>
      </div>
    )
  }
}

DashboardIdeaList.propTypes = {
  list: PropTypes.object.isRequired,
  listId: PropTypes.string.isRequired,
  listStyle: PropTypes.object.isRequired,
  isDragging: PropTypes.bool.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  connectDragSource: PropTypes.func.isRequired,  
  children: PropTypes.node,
}

export default DashboardIdeaList



// WEBPACK FOOTER //
// ./src/components/DashboardIdeaList.js